import { Injectable } from '@angular/core';
import { Constants } from '../constants';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class LandingRedirectService {

  computedQuestionCodes: Array<any> = Array<any>();

  constructor(
    private authService: AuthenticationService,
    private localStorageService: LocalStorageService) { }

  isControlAuthorized(authorizedControlList: any, controlKey: string, extensionPermissions: any): boolean {
    let hasAccess = false;
    if (!isNullOrUndefined(authorizedControlList)) {
      authorizedControlList.forEach(element => {
        if (element.key === controlKey) {
          const groups = element.groups.split(',');
          groups.forEach(claimGroup => {
            extensionPermissions.forEach(permission => {
              if (permission === claimGroup) { hasAccess = true; }
            });
          });
        }
      });
    }
    return hasAccess;
  }
}
